const AppLogomark = ({ size = 32, color = "currentColor", accentColor }) => {
  const accent = accentColor ?? color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16 2L28 8.5V23.5L16 30L4 23.5V8.5L16 2Z"
        fill={color}
        fillOpacity={0.15}
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <circle
        cx="22"
        cy="10"
        r="3.5"
        fill="none"
        stroke={accent}
        strokeWidth={1.25}
      />
      <circle cx="22" cy="10" r="1" fill={accent} />
      <text
        x="16"
        y="21"
        textAnchor="middle"
        fill={color}
        fontFamily="Rajdhani, sans-serif"
        fontWeight="700"
        fontSize="11"
        letterSpacing="-0.5"
      >
        ST
      </text>
    </svg>
  );
};

export default AppLogomark;
